import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';

export const getInitialQuoteAccessorials = () => {
  return axiosInstance.request({
    method: `get`,
    url: `${API.PRIMARY}/accessorials`,
  });
};

export type InitialAccessorialsListItem = {
  accChargeType: string;
  customKey: number;
  codeDesc: string;
  codeId: string;
  lookupKey: number;
  lookupCodeType: string;
  isChecked: number;
};

export type ModelGetInitialQuoteAccessorials = InitialAccessorialsListItem[] | undefined;

export const fetchInitialQuoteAccessorials = async (): Promise<ModelGetInitialQuoteAccessorials> => {
  const response: AxiosResponse<ModelGetInitialQuoteAccessorials> = await getInitialQuoteAccessorials();
  return response.data;
};
